import { tv } from 'tailwind-variants';

export const styles = tv({
  base: `
    relative
    flex
    h-16
    w-16
    flex-[0_0_auto]
    items-center
    justify-center
    rounded-full
    border-2
    last:mb-0
    last:mr-2
    focus:outline-none
    md:last:mb-2
    md:last:mr-0
    [&_img]:rounded-full
    [&_img]:object-cover
  `,
  slots: {
    playButton: `
      absolute
      z-10
      h-4
      w-4
      text-white
      drop-shadow-lg
    `,
  },
  variants: {
    isActive: {
      true: `
        border-green-700
      `,
      false: `
        border-gray-400
        opacity-50
      `,
    },
  },
});
